import React, { useEffect, useState, useRef } from "react";
import {
  Autocomplete,
  GoogleMap,
  useJsApiLoader,
  Circle,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import SweetAlert2 from "react-sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import {
  setSelectedServiceOption,
  setOrderProcessingDate,
  setSelectedAddress,
} from "../../redux/publicReducer/actions";
import { object } from "yup";

const storeName = process.env.REACT_APP_RESTAURANT_NAME;
const storeAddress = process.env.REACT_APP_RESTAURANT_ADDRESS;

export const DeliveryMap = (props) => {
  //---Map---//
  const [autoComplete, setAautoComplete] = useState();
  const [delAddress, setDelAddress] = useState("");

  const [chargePerMile, setChargePerMile] = useState([
    { miles: 0, charge: 4.0 },
    { miles: 1, charge: 4.0 },
    { miles: 2, charge: 4.0 },
    { miles: 3, charge: 4.0 },
    { miles: 4, charge: 4.0 },
    { miles: 5, charge: 4.0 },
    { miles: 6, charge: 4.0 },
    { miles: 7, charge: 4.0 },
    { miles: 8, charge: 4.0 },
    { miles: 9, charge: 4.0 },
    { miles: 10, charge: 4.0 },
    { miles: 11, charge: 4.0 },
    { miles: 12, charge: 4.0 },
    { miles: 13, charge: 4.0 },
    { miles: 14, charge: 4.0 },
    { miles: 15, charge: 4.0 },
    { miles: 16, charge: 4.0 },
    { miles: 17, charge: 4.0 },
    { miles: 18, charge: 4.0 },
    { miles: 19, charge: 4.0 },
    { miles: 20, charge: 4.0 },
    { miles: 21, charge: 4.0 },
    { miles: 22, charge: 4.0 },
    { miles: 23, charge: 4.0 },
    { miles: 24, charge: 4.0 },
    { miles: 25, charge: 4.0 },
  ]);

  const [swalProps, setSwalProps] = useState({});
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const dispatch = useDispatch();
  const { orderProcessingDate, orderProcessingType, selectedAddress } =
    useSelector((state) => state.public);

  const mapRef = useRef();

  useEffect(() => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps && window.google.maps.Map) {
      setIsScriptLoaded(true);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com"]'
    );
    if (existingScript) {
      // Script is already being loaded, wait for it
      const checkGoogleMaps = () => {
        if (window.google && window.google.maps && window.google.maps.Map) {
          setIsScriptLoaded(true);
        } else {
          setTimeout(checkGoogleMaps, 100);
        }
      };
      checkGoogleMaps();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_NEW_API_KEY_HERE&libraries=places,geometry&loading=async`;
    script.async = true;

    script.onload = () => {
      // Double check that all required APIs are loaded
      if (window.google && window.google.maps && window.google.maps.Map) {
        setIsScriptLoaded(true);
      } else {
        console.error("Google Maps API loaded but components not available");
      }
    };

    script.onerror = () => {
      console.error("Failed to load Google Maps script");
    };

    document.body.appendChild(script);

    // Cleanup function to remove script if component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (isScriptLoaded && mapRef.current) {
      initMap();
    }
  }, [isScriptLoaded]);

  const getMeters = (miles) => {
    return miles * 1609.344;
  };

  const getMiles = (meters) => {
    return meters * 0.000621371192;
  };

  const initMap = () => {
    // Additional safety check
    if (!window.google || !window.google.maps || !window.google.maps.Map) {
      console.error("Google Maps API not fully loaded");
      return;
    }

    const center = { lat: 42.386310397085964, lng: -87.92341897797219 }; // New York City coordinates

    const map = new window.google.maps.Map(mapRef.current, {
      zoom: 14,
      center,
    });

    const geofence = new window.google.maps.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      map,
      center,
      radius: getMeters(25), // 25 miles converted to meters
    });

    // Create the new PlaceAutocompleteElement
    if (
      !window.google.maps.places ||
      !window.google.maps.places.PlaceAutocompleteElement
    ) {
      console.error("Google Maps Places API not loaded");
      return;
    }

    const autocompleteElement =
      new window.google.maps.places.PlaceAutocompleteElement();
    autocompleteElement.id = "place-autocomplete";
    autocompleteElement.placeholder = "Type an address";

    // Style the autocomplete element to match the existing input
    autocompleteElement.style.position = "absolute";
    autocompleteElement.style.top = "55px";
    autocompleteElement.style.left = "10px";
    autocompleteElement.style.zIndex = "1";
    autocompleteElement.style.padding = "8px";
    autocompleteElement.style.borderRadius = "4px";
    autocompleteElement.style.border = "1px solid #aaa";
    autocompleteElement.style.width = "100%";
    autocompleteElement.style.maxWidth = "300px";
    autocompleteElement.style.height = "6vh";

    // Insert the autocomplete element into the map container
    const mapContainer = mapRef.current.parentNode;
    mapContainer.insertBefore(autocompleteElement, mapRef.current);

    map.addListener("click", (event) => {
      const clickedLatLng = event.latLng;
      const distanceFromCenter =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          clickedLatLng,
          geofence.getCenter()
        );

      if (distanceFromCenter <= geofence.getRadius()) {
        alert("Inside geofence");
      } else {
        alert("Outside geofence");
      }
    });

    autocompleteElement.addEventListener("gmp-placeselect", (event) => {
      const place = event.place;
      if (!place.geometry) {
        alert("No details available for input: " + place.name);
        return;
      }

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }

      const addressLatLng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      const distanceFromCenter =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          new window.google.maps.LatLng(addressLatLng),
          geofence.getCenter()
        );

      if (distanceFromCenter <= geofence.getRadius()) {
        const miles = Math.round(parseFloat(getMiles(distanceFromCenter)));
        const deliveryCharge = chargePerMile.find((m) => m.miles == miles);
        props.updateDeliveryCharge(
          deliveryCharge ? deliveryCharge.charge : chargePerMile[0].charge
        );

        try {
          console.log(place);
          selectedAddress.address = place.formattedAddress;

          // More robust way to extract city and zip code
          const addressComponents = place.addressComponents;
          let city = "";
          let zipCode = "";

          for (let component of addressComponents) {
            const types = component.types;
            if (types.includes("locality")) {
              city = component.longText;
            } else if (types.includes("postal_code")) {
              zipCode = component.longText;
            }
          }

          selectedAddress.city = city;
          selectedAddress.zipCode = zipCode;

          dispatch(setSelectedAddress(selectedAddress));
          setDelAddress(place.formattedAddress);
          setSwalProps({
            show: true,
            title: "Notification",
            text: "Thank you! Your address is within the delivery 25 miles radius.",
            icon: "success",
          });
        } catch (err) {
          console.log(err);

          setSwalProps({
            show: true,
            title: "Notification - Invalid Address",
            text: "Please specify Street Address.",
            icon: "warning",
          });
          props.setServiceOptionToPickup();
          setDelAddress("");
        }
      } else {
        setSwalProps({
          show: true,
          title: "Notification",
          text: "Sorry your location is outside the delivery 25 miles radius!",
          icon: "warning",
        });
      }
      props.setOpen(false);
    });
  };
  //---End Map---//

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          marginTop: "2vh",
        }}
      >
        <div id="map" ref={mapRef} style={{ width: "100%", height: "100vh" }} />
      </div>
      <SweetAlert2 {...swalProps} />
    </>
  );
};
